module.exports = __webpack_public_path__ + "static/media/pylon.2d338cb3.png";